import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from 'status-code-enum';

import {
  getPairing,
  getPairingPath,
  type GetPairingParam,
} from './get-api-v2-pairings-id';

type OptionType = Pick<UseQueryOptions, 'enabled'>;

export function usePairing(queryParams: GetPairingParam, options?: OptionType) {
  return useQuery({
    queryKey: [getPairingPath(queryParams)],

    queryFn: async () => {
      const resp = await getPairing(queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    enabled: options?.enabled === false || queryParams.id === 0 ? false : true,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
